<template>
  <div class="p-0 mb-0">
    <div class="spinner-wrapper" v-if="loading">
      <div class="spinner-border text-primary mb-1" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-else>
      <div v-if="organizationId">
        <div v-if="!donation.finished">
          <div class="card shadow-dark-md" id="payment-card" ref="payment-card">
            <form>
              <div v-show="!donation.creditCard">
                <div class="form-group mb-2 amount-selector">
                  <AmountSelector
                    :donation="donation"
                    :organization="organization"
                  />

                  <!-- <h3 class="mb-2">Choose your amount</h3> -->
                  <!-- <div class="d-flex align-items-edges">
                    <div
                      class="
                        custom-control
                        col-auto
                        custom-switch
                        align-self-center
                      "
                    >
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="monthly"
                        v-model="donation.monthly"
                        true-value="1"
                        false-value="0"
                      />
                      <label class="custom-control-label" for="monthly"
                        ><template v-if="donation.monthly == 0">
                          Make it a monthly donation
                        </template>
                        <template v-else>
                          Repeat this for
                          <input
                            id="months"
                            type="number"
                            min="2"
                            class="form-control form-control-xs"
                            aria-describedby="helpId"
                            placeholder=""
                            v-model="donation.months"
                          />
                          months
                        </template></label
                      >
                    </div>
                    <select
                      class="form-control form-control-xs"
                      id="currency"
                      v-model="donation.currency"
                      @change="currency_code = donation.currency.currency"
                    >
                      <option
                        v-bind:value="currency"
                        v-for="currency in currencies"
                        v-bind:key="currency.id"
                      >
                        {{ currency.symbol }} {{ currency.currency }}
                      </option>
                    </select>
                  </div> -->
                  <!-- <small
                    class="text-danger"
                    v-if="
                      $store.state.country == 'us' && currency_code != 'USD'
                    "
                    ><small>
                      Please note that your receipt will be issued in the USD
                      equivalent
                    </small></small
                  >
                  <small
                    class="text-danger"
                    v-else-if="
                      $store.state.country == 'can' && currency_code != 'CAD'
                    "
                    ><small>
                      Please note that your receipt will be issued in the CAD
                      equivalent
                    </small></small
                  > -->
                  <!-- <div class="btn-row first-row mt-5">
                    <a
                      href="#!"
                      @click.prevent="setAmount(50)"
                      :class="[donation.amount == 50 ? 'active' : '']"
                      class="btn btn-success col-4"
                      ><small>{{ donation.currency.symbol }}</small
                      >50<span v-if="donation.monthly == 1">/m</span></a
                    >
                    <a
                      href="#!"
                      @click.prevent="setAmount(100)"
                      :class="[donation.amount == 100 ? 'active' : '']"
                      class="btn btn-success col-4 border-right border-left"
                      ><small>{{ donation.currency.symbol }}</small
                      >100<span v-if="donation.monthly == 1">/m</span></a
                    >
                    <a
                      href="#!"
                      @click.prevent="setAmount(180)"
                      :class="[donation.amount == 180 ? 'active' : '']"
                      class="btn btn-success col-4"
                      ><small>{{ donation.currency.symbol }}</small
                      >180<span v-if="donation.monthly == 1">/m</span></a
                    >
                  </div>
                  <div class="btn-row">
                    <a
                      href="#!"
                      @click.prevent="setAmount(250)"
                      :class="[donation.amount == 250 ? 'active' : '']"
                      class="btn btn-success col-4"
                      ><small>{{ donation.currency.symbol }}</small
                      >250<span v-if="donation.monthly == 1">/m</span></a
                    >
                    <a
                      href="#!"
                      @click.prevent="setAmount(500)"
                      :class="[donation.amount == 500 ? 'active' : '']"
                      class="btn btn-success col-4 border-right border-left"
                      ><small>{{ donation.currency.symbol }}</small
                      >500<span v-if="donation.monthly == 1">/m</span></a
                    >
                    <a
                      href="#!"
                      @click.prevent="setAmount(1000)"
                      :class="[donation.amount == 1000 ? 'active' : '']"
                      class="btn btn-success col-4"
                      ><small>{{ donation.currency.symbol }}</small
                      >1000<span v-if="donation.monthly == 1">/m</span></a
                    >
                  </div>
                  <div class="btn-row last-row">
                    <a
                      href="#!"
                      @click.prevent="setAmount(1800)"
                      :class="[donation.amount == 1800 ? 'active' : '']"
                      class="btn btn-success col-4"
                      ><small>{{ donation.currency.symbol }}</small
                      >1800<span v-if="donation.monthly == 1">/m</span></a
                    >
                    <input
                      name="amount"
                      id="amount"
                      class="btn btn-success col-8 border-left"
                      placeholder="Other amount"
                      v-model="nameAmount"
                      :class="[nameAmount > 0 ? 'active' : '']"
                      @click="donation.amount = 0"
                    />
                  </div>-->
                </div>
                <div class="d-flex align-items-edges mb-2">
                  <div
                    class="custom-control col-auto custom-switch align-self-center"
                  >
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="tip"
                      v-model="donation.tip"
                      true-value="1"
                      false-value="0"
                    />
                    <label class="custom-control-label" for="tip"
                      >I wish to add 5% to my donation to help offset processing
                      fees
                    </label>
                  </div>
                </div>
                <!-- <div class="form-group mb-2 d-flex align-items-center">
                  <small class="text-muted">
                    <p class="mb-0">
                      You're donating through
                      <span v-if="$store.state.country == 'us'"
                        >Ne'eman Foundation USA</span
                      ><span v-else>The Emunim Fund CANADA</span>.
                      <br />
                      <a
                        :href="
                          '/projects/' +
                          organization.id +
                          '?country=' +
                          $store.state.country
                        "
                        target="_blank"
                        >Click here</a
                      >
                      if you wish to donate on the Ne'eman Foundation website
                    </p>
                  </small>
                </div> -->
                <div class="form-group">
                  <div class="custom-control custom-switch">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="allocate"
                      v-model="donation.allocate"
                      true-value="1"
                      false-value="0"
                    />
                    <label class="custom-control-label" for="allocate">
                      Allocate/Dedicate Your Donation
                    </label>
                  </div>
                  <textarea
                    v-if="donation.allocate == 1"
                    v-model="donation.allocation"
                    placeholder="Write your allocation..."
                    class="form-control my-2"
                  ></textarea>
                </div>
                <div class="form-group mb-0">
                  <button
                    @click="continueWithCard"
                    type="button"
                    class="btn btn-card btn-block"
                  >
                    <i class="far fa-credit-card"></i> Credit card
                  </button>
                  <!-- Stripe Payment Request Button + PayPal side-by-side when wallet pay is available -->
                  <div
                    class="mt-1"
                    :class="
                      walletPayAvailable ? 'd-flex align-items-stretch' : ''
                    "
                  >
                    <!-- Stripe Payment Request Button (Google Pay / Apple Pay) -->
                    <div
                      ref="prButton"
                      class="flex-grow-1 mr-1"
                      v-show="walletPayAvailable"
                    ></div>
                    <!-- PayPal -->
                    <form
                      action="https://www.paypal.com/cgi-bin/webscr"
                      method="post"
                      target="_blank"
                      :class="walletPayAvailable ? '' : 'w-100'"
                    >
                      <input
                        type="hidden"
                        name="currency_code"
                        v-model="currency_code"
                      />
                      <input
                        type="hidden"
                        name="item_name"
                        v-model="organization.name"
                      />
                      <input
                        name="business"
                        type="hidden"
                        :value="[
                          $store.state.country == 'can'
                            ? 'theneemanfoundation@gmail.com'
                            : 'neemanusa@gmail.com',
                        ]"
                      />
                      <input
                        name="custom"
                        id="pp-custom"
                        type="hidden"
                        :value="organization.id + '|' + donation.allocation"
                      />

                      <input type="hidden" name="no_shipping" value="1" />
                      <input
                        name="cmd"
                        type="hidden"
                        :value="[
                          donation.monthly == 0
                            ? '_donations'
                            : '_xclick-subscriptions',
                        ]"
                      />
                      <input
                        name="amount"
                        type="hidden"
                        v-model="donation.amount"
                        v-if="donation.monthly == 0"
                      />
                      <template v-else>
                        <input
                          type="hidden"
                          name="a3"
                          v-model="donation.amount"
                        />
                        <input type="hidden" name="p3" value="1" />
                        <input type="hidden" name="t3" value="M" />
                        <input type="hidden" name="src" value="1" />
                        <input
                          type="hidden"
                          name="srt"
                          :value="donation.months"
                        />
                        <input name="no_note" type="hidden" value="1" />
                      </template>
                      <input name="lc" type="hidden" value="CA" />
                      <input name="bn" type="hidden" value="PP-BuyNowBF" />
                      <input
                        name="return"
                        type="hidden"
                        value="https://neemanfoundation.com/thank_you/"
                      />
                      <input
                        name="notify_url"
                        type="hidden"
                        value="https://app.neemanfoundation.com/gateway/paypal/"
                      />
                      <button
                        type="submit"
                        @click="
                          if (donation.nameAmount > 0) {
                            donation.amount = donation.tip
                              ? donation.nameAmount * 1.05
                              : donation.nameAmount;
                          } else {
                            donation.amount = donation.tip
                              ? donation.amount * 1.05
                              : donation.amount;
                          }
                        "
                        :class="[
                          'btn',
                          'btn-paypal',
                          walletPayAvailable ? 'h-100' : 'btn-block',
                        ]"
                      >
                        <i class="fab fa-cc-paypal"></i>
                        <span v-if="!walletPayAvailable"> PayPal</span>
                      </button>
                    </form>
                  </div>
                  <div
                    v-if="walletPayError"
                    class="alert alert-danger mt-2 mb-0 py-2 px-3 small"
                  >
                    {{ walletPayError }}
                  </div>
                </div>
              </div>

              <div
                id="credit-card-form"
                class="overflow-auto h-100"
                v-if="donation.creditCard"
              >
                <credit-card-form
                  :show-card="false"
                  :donation.sync="donation"
                  :organization="organization"
                />
              </div>
            </form>
            <div class="secure-footer">
              <div
                class="text-muted d-flex justify-content-center align-items-center"
              >
                <i class="fad fa-lock-alt fa-2x mr-3 text-success"></i>
                <span style="line-height: 1">Safe and Secure Payments</span>
                <i class="fab fa-lg ml-5 fa-cc-visa text-info"></i>
                <i class="fab fa-lg ml-2 fa-cc-amex text-info"></i>
                <i class="fab fa-lg ml-2 fa-cc-mastercard text-info"></i>
                <i class="fab fa-lg ml-2 fa-cc-diners-club text-info"></i>
                <i class="fab fa-lg ml-2 fa-cc-apple-pay text-info"></i>
                <i class="fab fa-lg ml-2 fa-google-wallet text-info"></i>
              </div>
            </div>
          </div>
        </div>
        <div
          id="thank-you-wrapper"
          v-else
          class="py-10 px-10 border border-default rounded mb-10 text-center shadow-lift"
        >
          <h1 class="text-center mb-0">Thank you for your support</h1>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { EventBus } from "../event-bus.js";
import CreditCardForm from "../components/CreditCardForm";
import AmountSelector from "../components/AmountSelector";

export default {
  components: {
    CreditCardForm,
    AmountSelector,
  },
  props: {},
  data() {
    return {
      currency_code: "",
      currencies: [],
      organization: {},
      donation: {
        currency: {},
        amount: 50,
        finished: false,
        creditCard: false,
        cardName: "",
        cardEmail: "",
        cardNumber: "",
        cardMonth: "",
        cardYear: "",
        cardCvv: "",
        city: "",
        state: "",
        zip: "",
        country_id: "",
        address: "",
        monthly: 0,
        months: 12,
        allocation: "",
        nameAmount: "",
      },
      allocation: "",
      loading: true,
      allocationFinished: false,
      walletPayAvailable: false,
      walletPayError: "",
      stripeElements: null,
      stripeInstance: null,
      expressCheckoutElement: null,
      stripeCurrency: null,
    };
  },
  watch: {
    $route() {
      this.getOrganition();
    },
    "donation.amount"() {
      this.updateStripePaymentRequest();
    },
    "donation.nameAmount"() {
      this.updateStripePaymentRequest();
    },
    "donation.tip"() {
      this.updateStripePaymentRequest();
    },
    "donation.monthly"() {
      this.updateStripePaymentRequest();
    },
    "donation.currency"(val) {
      if (val && val.currency) {
        this.initStripePaymentRequest();
      }
    },
  },
  mounted() {
    document.body.className = "embed";

    this.$store.state.country = this.$route.params.country;
    this.getOrganition();
    let self = this;
    this.axios
      .get(window.API_URL + "currencies")
      .then(function (response) {
        self.currencies = response.data;
        if (self.$store.state.country === "us")
          self.donation.currency = self.currencies[0];
        else self.donation.currency = self.currencies[1];
        self.currency_code = self.donation.currency.currency;
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  computed: {
    organizationId() {
      return this.organization[this.$store.state.country + "_code"];
    },
    amnts() {
      if (this.organization.amount_type_id == 2) {
        return JSON.parse(this.organization.amounts);
      } else {
        return [50, 100, 180, 250, 500, 1000, 1800];
      }
    },
    effectiveAmount() {
      const base =
        this.donation.nameAmount > 0
          ? parseFloat(this.donation.nameAmount)
          : parseFloat(this.donation.amount);
      return this.donation.tip == 1
        ? Math.round(base * 1.05 * 100)
        : Math.round(base * 100);
    },
  },
  methods: {
    getOrganition() {
      let self = this;
      this.axios
        .get(window.API_URL + "organizations/" + this.$route.params.id)
        .then(function (response) {
          self.organization = response.data;
          self.loading = false;
          self.donation.amount = self.amnts[0];
        })
        .catch(function (error) {});
    },
    setAmount(amount) {
      this.donation.amount = amount;
      this.donation.nameAmount = "";
    },
    continueWithCard() {
      this.donation.creditCard = true;
      if (this.donation.nameAmount > 0) {
        this.donation.amount = this.donation.nameAmount;
      }
    },
    // allocate() {
    //   let self = this;
    //   this.axios
    //     .post(window.API_URL + "allocate", {
    //       id: this.donation.id,
    //       allocation: this.allocation,
    //     })
    //     .then(function (response) {
    //       self.allocationFinished = true;
    //     })
    //     .catch(function (error) {});
    // },
    toggleCountry() {
      EventBus.$emit("switchCountry");
    },
    updateStripePaymentRequest() {
      if (!this.stripeElements || this.effectiveAmount <= 0) return;
      this.stripeElements.update({ amount: this.effectiveAmount });
    },
    async initStripePaymentRequest() {
      if (
        !window.Stripe ||
        !window.STRIPE_PK ||
        !this.donation.currency ||
        !this.donation.currency.currency
      ) {
        return;
      }
      try {
        const newCurrency = this.donation.currency.currency.toLowerCase();
        // Avoid re-mounting if already initialised for the same currency
        if (this.stripeInstance && this.stripeCurrency === newCurrency) return;

        // Reset state when re-initializing for a new currency
        if (this.expressCheckoutElement) {
          try {
            this.expressCheckoutElement.unmount();
          } catch (e) {}
          this.expressCheckoutElement = null;
        }
        this.stripeInstance = null;
        this.stripeElements = null;
        this.walletPayAvailable = false;
        this.stripeCurrency = newCurrency;

        const stripe = window.Stripe(window.STRIPE_PK);
        this.stripeInstance = stripe;

        const elements = stripe.elements({
          mode: "payment",
          amount: this.effectiveAmount,
          currency: newCurrency,
          paymentMethodCreation: "manual",
        });
        this.stripeElements = elements;

        const expressCheckoutElement = elements.create("expressCheckout", {
          paymentMethods: {
            applePay: "always",
            googlePay: "always",
            link: "never",
            amazonPay: "never",
            paypal: "never",
          },
        });
        this.expressCheckoutElement = expressCheckoutElement;

        expressCheckoutElement.on("ready", ({ availablePaymentMethods }) => {
          if (availablePaymentMethods) {
            this.walletPayAvailable = true;
            this.$nextTick(() => {
              if (this.$refs.prButton) {
                expressCheckoutElement.mount(this.$refs.prButton);
              }
            });
          }
        });

        expressCheckoutElement.on("confirm", async (event) => {
          try {
            const { paymentMethod, error: pmError } =
              await stripe.createPaymentMethod({ elements });
            if (pmError) {
              this.walletPayError =
                pmError.message || "Payment failed. Please try again.";
              return;
            }
            if (!paymentMethod) {
              this.walletPayError = "Payment failed. Please try again.";
              return;
            }

            const payload = {
              payment_method: paymentMethod.id,
              cardEmail: paymentMethod.billing_details?.email || "",
              cardName: paymentMethod.billing_details?.name || "",
              amount: this.effectiveAmount / 100,
              currency: this.donation.currency,
              organization_id: this.organization.id,
              organization_name: this.organization.name,
              code: this.organization[this.$store.state.country + "_code"],
              country: this.$store.state.country,
              allocation: this.donation.allocation,
              monthly: this.donation.monthly,
              months: this.donation.months,
            };

            const response = await this.axios.post(
              window.API_URL + "process_wallet",
              payload
            );

            if (response.data.requires_action && response.data.client_secret) {
              // Backend confirmed the intent but 3DS authentication is required
              const { error } = await stripe.handleNextAction({
                clientSecret: response.data.client_secret,
              });
              if (error) {
                this.walletPayError =
                  error.message || "Payment failed. Please try again.";
              } else {
                this.donation.finished = true;
              }
            } else if (response.data.status === "success") {
              this.donation.finished = true;
            } else {
              this.walletPayError =
                response.data.message || "Payment failed. Please try again.";
            }
          } catch (err) {
            console.error("Wallet payment error:", err);
            this.walletPayError = "An error occurred. Please try again.";
          }
        });
      } catch (err) {
        console.error("Stripe Express Checkout init error:", err);
      }
    },
  },
};
</script>

<style lang="scss">
body.embed {
  background: transparent;
  padding: 0;
  .mb-0.mb-10 {
    margin-bottom: 0 !important;
  }
  #enable-toolbar {
    display: none;
  }
  small p,
  small label {
    font-size: 12px;
  }
}
.content {
  p,
  h1,
  h2,
  h3,
  h4,
  .h1,
  .h2,
  .h3,
  .h4,
  ul,
  ol {
    color: #fff;
  }
}
// .amount-selector {
//   .btn.border-right {
//     border-right: 0.5px solid #2a8a6c !important;
//   }
//   .btn.border-left {
//     border-left: 0.5px solid #2a8a6c !important;
//   }
//   .btn.active {
//     background: #389e7f;
//     box-shadow: inset 0 0 10px rgba($color: #000000, $alpha: 0.3) !important;
//   }
//   .btn:not([class*="btn-outline"]) {
//     border-radius: 0;
//   }
//   .btn-row.first-row {
//     clear: both;
//     .btn {
//       border-bottom: 0.5px solid #2a8a6c !important;
//     }
//     .btn:first-child {
//       border-top-left-radius: 5px;
//     }
//     .btn:last-child {
//       border-top-right-radius: 5px;
//     }
//   }
//   .btn-row.last-row {
//     .btn {
//       border-top: 0.5px solid #2a8a6c !important;
//     }
//     .btn:first-child {
//       border-bottom-left-radius: 5px;
//     }
//     .btn:last-child {
//       border-bottom-right-radius: 5px;
//     }
//   }
// }
.vertical-input-group .input-group:first-child {
  padding-bottom: 0;
}
.vertical-input-group .input-group:first-child * {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.vertical-input-group .input-group:last-child {
  padding-top: 0;
}
.vertical-input-group .input-group:last-child * {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.vertical-input-group .input-group:not(:last-child):not(:first-child) {
  padding-top: 0;
  padding-bottom: 0;
}
.vertical-input-group .input-group:not(:last-child):not(:first-child) * {
  border-radius: 0;
}
.vertical-input-group .input-group:not(:first-child) * {
  border-top: 0;
}
.btn.btn-card {
  background-color: #263771;
  color: #fff;
}
.btn.btn-paypal {
  background-color: #0070ba;
  color: #fff;
}
.btn.btn-card:hover {
  background-color: darken(#263771, 10);
  color: #fff;
}
.btn.btn-paypal:hover {
  background-color: darken(#0070ba, 10);
  color: #fff;
}
.spinner-wrapper {
  display: block;
  width: 100%;
  height: 70vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.background-cover {
  background-size: cover;
  background-position: center;
}
.form-group {
  .btn-success {
    font-size: 25px;
    span {
      font-size: 14px;
      opacity: 0.7;
    }
  }
}
h3 .custom-control {
  margin-top: 3px;
}
h3 .custom-control-label {
  color: #161c2d;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  line-height: 1.7;
}
.secure-footer {
  background-color: rgba(0, 0, 0, 0.03);
  border-top: 1px solid rgba(0, 0, 0, 0.125);
  margin: 10px 0 0;
  padding: 30px 50px;
}
.custom-control-input:checked ~ .custom-control-label::before {
  background-color: #42ba96;
}
.custom-control-input:checked ~ .custom-control-label::after {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='green' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E");
}
#thank-you-wrapper.rounded {
  border-radius: 30px !important;
  background: rgba(255, 255, 255, 0.5);
}
#months {
  display: inline-block;
  text-align: center;
  margin: 0 3px;
  width: 3em;
  box-sizing: content-box;
  padding: 0 2px;
  height: 24px;
  border-color: #ddd;
}
@media (max-width: 544px) {
  .btn {
    padding: 0.8125rem 0.25rem;
  }
}
// #amount {
//   -webkit-user-select: text;
//   user-select: text;
// }
</style>
